module.exports = __webpack_public_path__ + "static/media/icon-rep-incompleta.6566d1e8.png";